module.exports = __webpack_public_path__ + "img/anOrrery.7c26b6d0.jpg";